export const getPricingTitleInternal = () => {
    return "Confluence Pricing Page";
};
